import Icon from '../components/Icon.vue'

Icon.register({
  'air-freshener': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M378.9 321.4c11.8 12.1 1.7 30.6-16.6 30.6h-138.3v32h112c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-288c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h112v-32h-138.3c-18.4 0-28.4-18.4-16.6-30.6l94.2-97.4h-49.2c-15.3 0-23.7-16.6-13.9-27.5l113.3-126.5c-3.4-6.6-5.5-14-5.5-22 0-26.5 21.5-48 48-48s48 21.5 48 48c0 8-2.1 15.3-5.5 22l113.3 126.5c9.8 10.9 1.4 27.5-13.9 27.5h-49.2zM192 32c-8.8 0-16 7.2-16 16 0 8.8 7.2 16 16 16s16-7.2 16-16c0-8.8-7.2-16-16-16zM304 432h-224v32h224v-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/air-freshener.js
// module id = 593
// module chunks = 0